



















































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';

export default Vue.extend({

  name: 'ConfirmationDialog',

  components: {
  },

  props: {
    btnText: {
      type: String,
      default:  'Confirm',
    },
    confirmText: {
      type: String,
      default:  'Are you sure?',
    },
    confirmTitle: {
      type: String,
      default:  'Confirm Action',
    },
    btnColour: {
      type: String,
      default:  'white',
    },
    emitData: {
      type: Object,
      default:  null,
    },
    icon: {
      type: String,
      default:  '',
    },
    iconSize: {
      type: String,
      default:  'medium',
    },
    iconColour: {
      type: String,
      default:  '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    dialogProp: {
      type: Boolean,
      default: false,
    },
    dialogRemember: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dialog: this.dialogProp,
      remember: this.dialogRemember,
    };
  },

  created() {
    console.log('[ ConfirmantionDialog created() ]');
  },

  mounted() {
  },

  watch: {
    dialogProp(newVal, oldVal) {
      this.dialog = newVal;
    },
    dialogRemember(newVal, oldVal) {
      this.remember = newVal;
    },
    dialog(newVal, oldVal) {
      if (!newVal) {
        this.$emit('close-dialog');
      }
    },
  },

  computed: {
  },

  methods: {

      agree() {
        this.dialog = false;
        this.$emit('agree', this.emitData)
      },

      disagree() {
        this.dialog = false;
        this.$emit('disagree', this.emitData)
      }
    
  },


});

